const {
	$
} = window;

const Pie = {
	renderPies: selector => {
		setTimeout(() => {
			if('easyPieChart' in $()) {
				if($(selector).length) {
					$(selector).each((i, v) => {
						$(v).easyPieChart({
							animate: 2000,
							lineWidth: 5,
							barColor: $(v).attr('data-color'),
							lineCap: "square",
						})
					})
				}
			}
		}, 0)
	},

	renderCounterUp: () => {
		setTimeout(() => {
			if('counterUp' in $()) {
				$("[data-counter='counterup']").counterUp({
					delay: 10,
					time: 1000
				});
			}
		}, 0)
	}
}

export default Pie;


// WEBPACK FOOTER //
// ./src/helper/piechart.helper.js